// generated by scripts/generate_navigation_contract_types.py; contract-sha256: a497d2e927c21b45452cfac090bf8b45233582595be6cc8051de8966e2739b4b
// server-contract-sha256: c6ff13197318fc1bfc189080149d7360df07998721fc174cc801fa71706356e5 (ai_engine agent/navigation_contract_digest.txt)
/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export type paths = Record<string, never>;
export type webhooks = Record<string, never>;
export type components = {
    schemas: {
        /**
         * NavigationRoute
         * @description Route-ready ingredients, resolved server-side, and the path they open. Absent fields are omitted, never null.
         */
        NavigationRoute: {
            /**
             * Documentid
             * @description The OWNING drawing-set or document file id.
             * @default null
             */
            documentId?: string | null;
            /**
             * Hl
             * @description sheet_region: page,xMin,yMin,xMax,yMax.
             * @default null
             */
            hl?: string | null;
            /**
             * Href
             * @description The app path the card opens (navigation_href), relative to the project's app root. Written by the server, on every card it sends; a client opens it and never builds a path of its own.
             * @default null
             */
            href?: string | null;
            /**
             * Layers
             * @description sheet_overlay: the stack drawn over the base sheet, bottom first.
             * @default null
             */
            layers?: components["schemas"]["OverlayLayerRoute"][] | null;
            /**
             * Nodeid
             * @default null
             */
            nodeId?: string | null;
            /**
             * Overlaysectiongroupid
             * @description Legacy: the first layer's sectionGroupId, for older clients.
             * @default null
             */
            overlaySectionGroupId?: string | null;
            /**
             * Overlaysheet
             * @description Legacy: the first layer's fileId, for older clients.
             * @default null
             */
            overlaySheet?: string | null;
            /**
             * Rfiid
             * @default null
             */
            rfiId?: string | null;
            /**
             * Sectiongroupid
             * @description The sheet (the base sheet for an overlay).
             * @default null
             */
            sectionGroupId?: string | null;
            /**
             * Submittalid
             * @default null
             */
            submittalId?: string | null;
            /**
             * Zoomto
             * @description sheet_overlay: x0,y0,x1,y1 on the base sheet.
             * @default null
             */
            zoomTo?: string | null;
        };
        /**
         * NavigationSuggestedEvent
         * @description The whole ``navigation_suggested`` event data, and a ``navigation`` part's payload.
         */
        NavigationSuggestedEvent: {
            /**
             * Kind
             * @enum {string}
             */
            kind:
                | "sheet"
                | "sheet_region"
                | "sheet_overlay"
                | "section"
                | "workbench"
                | "document"
                | "rfi"
                | "submittal"
                | "submittal_register"
                | "constructability_review"
                | "documents"
                | "home"
                | "search"
                | "control_tower"
                | "rfis"
                | "submittals"
                | "rfi_assistant"
                | "submittal_registry"
                | "revisions"
                | "integrations"
                | "upload";
            /** Label */
            label: string;
            /**
             * Mode
             * @default offer
             * @enum {string}
             */
            mode?: "open" | "offer";
            /**
             * Note
             * @default null
             */
            note?: string | null;
            route: components["schemas"]["NavigationRoute"];
        };
        /**
         * OverlayLayerRoute
         * @description One sheet drawn over the base.
         */
        OverlayLayerRoute: {
            /**
             * Fileid
             * @description The layer sheet's OWN PrimeFile id, never its section group or document id.
             */
            fileId: string;
            /**
             * Sectiongroupid
             * @description The layer sheet's section group id: the exact revision.
             */
            sectionGroupId: string;
        };
    };
    responses: never;
    parameters: never;
    requestBodies: never;
    headers: never;
    pathItems: never;
};
export type $defs = Record<string, never>;
export type operations = Record<string, never>;

/** Every kind the engine can emit. */
export const NAVIGATION_KINDS = [
    "sheet",
    "sheet_region",
    "sheet_overlay",
    "section",
    "workbench",
    "document",
    "rfi",
    "submittal",
    "submittal_register",
    "constructability_review",
    "documents",
    "home",
    "search",
    "control_tower",
    "rfis",
    "submittals",
    "rfi_assistant",
    "submittal_registry",
    "revisions",
    "integrations",
    "upload",
] as const;

/** The route fields that hold a plain string. */
export const NAVIGATION_ROUTE_STRING_KEYS = [
    "documentId",
    "sectionGroupId",
    "nodeId",
    "rfiId",
    "submittalId",
    "hl",
    "zoomTo",
    "overlaySheet",
    "overlaySectionGroupId",
    "href",
] as const;

/** The most layers an overlay holds on its base sheet (the viewer's stack cap). */
export const OVERLAY_MAX_LAYERS = 8;

export type NavigationSuggestedEventData = components["schemas"]["NavigationSuggestedEvent"];
export type NavigationSuggestionRoute = components["schemas"]["NavigationRoute"];
export type OverlayLayerRoute = components["schemas"]["OverlayLayerRoute"];
export type NavigationSuggestionKind = (typeof NAVIGATION_KINDS)[number];
export type NavigationSuggestionMode = NonNullable<NavigationSuggestedEventData["mode"]>;
